export default "__VITE_ASSET__9bfc4312__"